import { Routes, Route, Navigate } from "react-router-dom";

import DashboardLayout from "components/Dashboard/DashboardLayout";
import AuthLayout from "layouts/Auth.js";
import PaymentSuccess from "views/vismapay/PaymentSuccess/PaymentSuccess"
import PaymentCancelled from "views/vismapay/PaymentCancelled/PaymentCancelled"
import { useAuthContext } from "contexts/AuthContext";

import { Container } from "stories/layout";
import { Spinner } from "stories/components";

const App = () => {
  const { isAuthenticated, loadingMyUser } = useAuthContext();

  if (loadingMyUser ) {
    return (
      <Container className="d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
        <Spinner animation="border" role="status" className="text-secondary"/>
      </Container>
    )
  }
  
  return (
    <>
      { isAuthenticated === true  ? (
        <Routes>
          <Route path="/dashboard/*" element={<DashboardLayout />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancelled" element={<PaymentCancelled />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/auth/*" element={<AuthLayout />} />
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      )}
      
    </>
  )
}

export default App;